module.exports = __webpack_public_path__ + "img/tq.b4fe16a6.png";